import { render, staticRenderFns } from "./simulated.vue?vue&type=template&id=78b92634&scoped=true&"
import script from "./simulated.vue?vue&type=script&lang=js&"
export * from "./simulated.vue?vue&type=script&lang=js&"
import style0 from "./simulated.vue?vue&type=style&index=0&id=78b92634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b92634",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderBar: require('/builds/mytia/mege-educacional/components/HeaderBar.vue').default})
